import { useRoleAccessContext } from "../context/roleAccessContext";

export const useCanAccess = () => {
  const { accessSections } = useRoleAccessContext();

  const can = (key: string) => {
    return accessSections?.includes(key);
  };

  return { can };
};
